import React from 'react';

function house_staking() {
	return (
		<div class="col-md-10">
			<div class="greeting">
				<img src={`${process.env.PUBLIC_URL}/images/panel2.png`} />
				<img src={`${process.env.PUBLIC_URL}/images/gdmobile.png`} />
			</div>
		</div>
	);
}

export default house_staking;
			